import React, { useState, useEffect } from "react";
import "./style.css";
import { useParams } from "react-router-dom";
import Pageloader from "../../../components/loader";
import {
  Typography,
  Button,
  Card,
  Descriptions,
  Space,
  Image,
  Skeleton,
  Tooltip,
  Modal,
  Avatar,
} from "antd";
import { RollbackOutlined,CheckSquareOutlined, UserOutlined, UploadOutlined } from "@ant-design/icons";
import {
  getReUpoadProfileImage,
  getRiderDetail,
  getRiderForceFree,
} from "../../../services/riders.service";
import RiderDetailShift from "./riderDetailShift";
import RiderDetailOrder from "./riderDetailOrder";
import RiderStatusLog from "./riderStatusLog";
import RiderEditModal from "../../../components/modal/riders/RiderEditModal";
import moment from "moment";
// import { getshiftList } from "../../../services/shift.service";
import { getZoneList } from "../../../services/zone.service";
import { DevProductPermissionHelper, userhasPermissionHelper, validationErrors } from "../../../utils/Helpers";
import { swalNotification } from "../../../components/alret/notificztion";
import RiderVisibleZones from "./riderVisibleZones";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PERMISSION_CONSTANT } from "../../../utils/constants/app";
import RiderProfileImageLog from "./riderProfileImageLog";
import RiderBatchLog from "./riderBatchLog";

const { Link, Title, Text } = Typography;

const RiderDetail = (props) => {
  const params = useParams();
  const { riderid } = params;
  const pagename = "Rider";
  const navigate = useNavigate();

  const [riderData, setRiderData] = useState([]);
  const [shiftsData, setShiftsData] = useState([]);
  const [VisibleZoneData, setvisibleZoneData] = useState([]);
  const [postDataZoneList, setPostDataZoneList] = useState([]);
  // const [riderShifts, setRiderShifts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState(null);

  useEffect(() => {
    // console.log("RiderData::: ", riderData);
    if (riderData) {
      setErrMsg(null);
    }
  }, [riderData]);
  // const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    postLists();
  }, []);

  const postLists = async () => {
    setLoading(true);
    postListsrefresh();
  };

  const postListsrefresh = async () => {
    try {
      const resp = await getRiderDetail(riderid);
      setRiderData(resp.data.data);
      const respZone = await getZoneList();
      setPostDataZoneList(respZone.data.data);
      filterPostDataRiderZoneslist(resp.data.data.zone, respZone.data.data);

      // const shiftList = await getshiftList();
      // setShiftsData(shiftList.data.data);

      // const riderShifts = await getSingleRiderShifts(riderid);
      // setRiderShifts(riderShifts.data.data);
    } catch (error) {
      // setErrMsg("Something went wrong");
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const filterPostDataRiderZoneslist = (RZones, ALLZones) => {
    // return null;
    const zoneDataFilter = [];
    RZones &&
      RZones.map((Ritem) => {
        ALLZones &&
          ALLZones.map((Zitem) => {
            if (Ritem.id == Zitem.id) {
              zoneDataFilter.push(<Text>{Zitem.zoneName}</Text>);
            }
          });
      });
    setvisibleZoneData(zoneDataFilter);
  };

  const [riderEditOpenModal, setRiderEditOpenModal] = useState(false);

  const [reUploadProfileImageModalOpen, setreUploadProfileImageModalOpen] = useState(false);
  const reUploadProfileImageShowModal = () => {
    setreUploadProfileImageModalOpen(true);
  };
  const reUploadProfileImageHandleCancel = () => {
    setreUploadProfileImageModalOpen(false);
  };
  const reUploadProfileImageHandleOk = async () => {
    try{
      setLoading(true);
      const resp = await getReUpoadProfileImage(riderid);
      if(resp.data.code == 200){
        swalNotification(resp.data.message)
      }
    }
    catch(e){
      swalNotification("Can not re-upload .", e.response.data.message, "error");
    }
    finally{
      setLoading(false);
      setreUploadProfileImageModalOpen(false);
    }
  };

  const [forceFreeRiderModalOpen, setForceFreeRiderModalOpen] = useState(false);
  const forceFreeRiderShowModal = () => {
    setForceFreeRiderModalOpen(true);
  };
  const forceFreeRiderHandleOk = async () => {
    try{
      setLoading(true);
      const resp = await getRiderForceFree(riderid);
      if(resp.data.code == 200){
        swalNotification(resp.data.message)
      }
    }
    catch(e){
      swalNotification("Can not force free.", e.response.data.message, "error");
      // validationErrors(e)
    }
    finally{
      setLoading(false);
      setForceFreeRiderModalOpen(false);
    }
  };
  const forceFreeRiderHandleCancel = () => {
    setForceFreeRiderModalOpen(false);
  };

  
  const data = [riderData];
  return (
    <div className="page-content">
      <Modal title="Re-upload Profile Image" visible={reUploadProfileImageModalOpen} onOk={reUploadProfileImageHandleOk} onCancel={reUploadProfileImageHandleCancel}>
        <p>Are you sure</p>
      </Modal>
      <Modal title="Force Free Rider" visible={forceFreeRiderModalOpen} onOk={forceFreeRiderHandleOk} onCancel={forceFreeRiderHandleCancel}>
        <p>Are you sure</p>
      </Modal>
      <RiderEditModal
        riderEditOpenModal={riderEditOpenModal}
        setRiderEditOpenModal={setRiderEditOpenModal}
      />
      <div className="page-content-header">
        <div className="pch-title">
          <Title level={2}>{pagename} Detail</Title>
        </div>
        <div className="pch-content">
          { userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_FORCE_FREE_RIDER) && 
            <Tooltip title="Force Free Rider">
              <Button onClick={forceFreeRiderShowModal}>
                <CheckSquareOutlined />
              </Button>
            </Tooltip>
          }
          <Button onClick={() => navigate("/rider")}>
            <RollbackOutlined />
          </Button>
        </div>
      </div>
      {loading ? (
        <Pageloader />
      ) : (
        <div className="p-content">
          <div className="page-content-header">
            <div
              className="pch"
              style={{
                maxWidth: "48%",
              }}
            >
              {data &&
                data.map((item, i) => {
                  return (
                    <Space
                      direction="vertical"
                      style={{
                        width: "100%",
                      }}
                    >
                      {item.profileImage ? (
                        <Image
                          alt="Profile Image"
                          src={item.profileImage}
                        />
                      ) : (
                        // <Skeleton.Image active />
                        <Avatar shape="square" size={64} icon={<UserOutlined />} />
                      )}
                      { userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RE_UPLOAD_PROFILE_IMAGE) &&
                        <Tooltip title="Re-upload Profile Image">
                          <Button onClick={reUploadProfileImageShowModal}>
                            <UploadOutlined />
                          </Button>
                        </Tooltip>
                      }
                      <Descriptions>
                        <Descriptions.Item label="Rider ID" span={3}>
                          {item.display_id ? item.display_id : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Tookan Rider ID" span={3}>
                          {item.fleet_id ? item.fleet_id : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Name" span={3}>
                          {item.fullName ? item.fullName : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Email" span={3}>
                          {item.email ? item.email : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Phone Number" span={3}>
                          {item.phoneNumber ? item.phoneNumber : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Date of birth" span={3}>
                          {item.dob
                            ? moment(item.dob).format("YYYY-MM-DD")
                            : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Status" span={3}>
                          {item.status ? item.status : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="CNIC" span={3}>
                          {item.cnic ? item.cnic : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="CNIC issue date" span={3}>
                          {item.cnic_issue_date
                            ? moment(item.cnic_issue_date).format("YYYY-MM-DD")
                            : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Vehicle" span={3}>
                          {item.vehicle ? item.vehicle : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="City" span={3}>
                          {item.city ? item.city : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Batch" span={3}>
                          {item.batch ? item.batch.batchLevel : ""}
                        </Descriptions.Item>
                        {/* <Descriptions.Item label="Zone" span={3}> */}
                        {/* {item.zone.zoneName ? item.zone.zoneName : "-"} */}
                        {/* </Descriptions.Item> */}
                        <Descriptions.Item label="Marital status" span={3}>
                          {item.marital_status ? item.marital_status : "-"}
                        </Descriptions.Item>
                        {item.next_of_kin && (
                          <Descriptions.Item label="Next of kin(Name)" span={3}>
                            {item.next_of_kin.name != null
                              ? item.next_of_kin.name
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.next_of_kin && (
                          <Descriptions.Item
                            label="Next of kin(Relation)"
                            span={3}
                          >
                            {item.next_of_kin.relation != null
                              ? item.next_of_kin.relation
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.next_of_kin && (
                          <Descriptions.Item
                            label="Next of kin(Phone Number)"
                            span={3}
                          >
                            {item.next_of_kin.number != null
                              ? item.next_of_kin.number
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.next_of_kin && (
                          <Descriptions.Item label="Next of kin(CNIC)" span={3}>
                            {item.next_of_kin.cnic != null
                              ? item.next_of_kin.cnic
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.payment && (
                          <Descriptions.Item
                            label="Payment(Jazz Cash)"
                            span={3}
                          >
                            {item.payment.jazz_cash != null
                              ? item.payment.jazz_cash
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.payment && (
                          <Descriptions.Item
                            label="Payment(Easypaisa)"
                            span={3}
                          >
                            {item.payment.easypaisa != null
                              ? item.payment.easypaisa
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.payment && (
                          <Descriptions.Item label="Payment(HBL)" span={3}>
                            {item.payment.hbl != null ? item.payment.hbl : "-"}
                          </Descriptions.Item>
                        )}
                        {item.payment && (
                          <Descriptions.Item
                            label="Payment(Bank Account)"
                            span={3}
                          >
                            {item.payment.bank_account != null
                              ? item.payment.bank_account
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.payment && (
                          <Descriptions.Item
                            label="Payment(ATM status)"
                            span={3}
                          >
                            {item.payment.atm_status != null
                              ? item.payment.atm_status
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.equipment && (
                          <Descriptions.Item
                            label="Equipment(Hand over date)"
                            span={3}
                          >
                            {item.equipment.hand_over_date != null
                              ? item.equipment.hand_over_date
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.equipment && (
                          <Descriptions.Item
                            label="Equipment(Returning date)"
                            span={3}
                          >
                            {item.equipment.returning_date != null
                              ? moment(item.equipment.returning_date).format(
                                  "YYYY-MM-DD"
                                )
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.equipment && (
                          <Descriptions.Item
                            label="Equipment(Delivery Bag)"
                            span={3}
                          >
                            {item.equipment.delivery_bag != null
                              ? moment(item.equipment.delivery_bag).format(
                                  "YYYY-MM-DD"
                                )
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.equipment && (
                          <Descriptions.Item
                            label="Equipment(T-shirt count)"
                            span={3}
                          >
                            {item.equipment.t_shirt_count != null
                              ? item.equipment.t_shirt_count
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.equipment && (
                          <Descriptions.Item
                            label="Equipment(Rain coats)"
                            span={3}
                          >
                            {item.equipment.rain_coats != null
                              ? item.equipment.rain_coats
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.equipment && (
                          <Descriptions.Item
                            label="Equipment(Rain jackets)"
                            span={3}
                          >
                            {item.equipment.rain_jackets != null
                              ? item.equipment.rain_jackets
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.equipment && (
                          <Descriptions.Item label="Equipment(Caps)" span={3}>
                            {item.equipment.caps != null
                              ? item.equipment.caps
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.equipment && (
                          <Descriptions.Item
                            label="Equipment(Shirt status)"
                            span={3}
                          >
                            {item.equipment.shirt_status != null
                              ? item.equipment.shirt_status
                              : "-"}
                          </Descriptions.Item>
                        )}
                        {item.equipment && (
                          <Descriptions.Item
                            label="Equipment(Winter jackets)"
                            span={3}
                          >
                            {item.equipment.cnic != null
                              ? item.equipment.cnic
                              : "-"}
                          </Descriptions.Item>
                        )}
                        <Descriptions.Item label="Device" span={3}>
                          {item.deviceType ? item.deviceType : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Searched face confidence registration" span={3}>
                          {item.searched_face_confidence_registration ? item?.searched_face_confidence_registration?.toFixed(2) : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Current OTP" span={3}>
                          {item.current_otp ? item.current_otp : "-"}
                        </Descriptions.Item>
                      </Descriptions>
                    </Space>
                  );
                })}
            </div>
            <div
              className="pch"
              style={{
                maxWidth: "48%",
              }}
            >
              <RiderVisibleZones
                VisibleZoneData={VisibleZoneData}
                postDataZoneList={postDataZoneList}
                postListsrefresh={postListsrefresh}
                riderData={data}
              />
            </div>
          </div>
          {data &&
            data.map((item, i) => {
              return (
                <Space
                  direction="vertical"
                  style={{
                    width: "100%",
                  }}
                >
                  <Space direction="horizontal">
                    <Card title="Bills Images" bordered>
                      <Image.PreviewGroup>
                        {item.bill ? (
                          <Image
                            alt="Bill Image"
                            src={item.bill}
                          />
                        ) : (
                          ""
                        )}
                      </Image.PreviewGroup>
                    </Card>
                    <Card title="CNIC Images" bordered>
                      <Image.PreviewGroup>
                        {item.cnicFront ? (
                          <Image
                            alt="CNIC Front Image"
                            src={item.cnicFront}
                          />
                        ) : (
                          ""
                        )}
                        {item.cnicBack ? (
                          <Image
                            alt="CNIC Back Image"
                            src={item.cnicBack}
                          />
                        ) : (
                          ""
                        )}
                      </Image.PreviewGroup>
                    </Card>
                    <Card title="license Images" bordered>
                      <Image.PreviewGroup>
                        {item.licenseFront ? (
                          <Image
                            alt="License Front Image"
                            src={item.licenseFront}
                          />
                        ) : (
                          ""
                        )}
                        {item.licenseBack ? (
                          <Image
                            alt="License Back Image"
                            src={item.licenseBack}
                          />
                        ) : (
                          ""
                        )}
                      </Image.PreviewGroup>
                    </Card>
                  </Space>
                </Space>
              );
            })}

          <Space
            direction="vertical"
            style={{width: "100%"}}
          >
            <RiderDetailShift RiderIDforShift={riderid} />
            <RiderDetailOrder RiderID={riderid} />
            <RiderStatusLog RiderID={riderid} />
            <RiderBatchLog RiderID={riderid} />
            <RiderProfileImageLog RiderID={riderid} />
          </Space>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    // authActions: bindActionCreators(authActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RiderDetail);
